/**
 * contactGroup模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const contactGroup = {
  //查询当前公司下有的联系人组
  listContactGroups(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/contactGroup/listContactGroups`,param);
  },
  // 联系人组创建
  createContactGroup(params) {
    return $http.post(`${global.API_URL}/sme/contactGroup/create`,params);
  },
  //联系人组分页
  pageContactGroup(params) {
    return $http.post(`${global.API_URL}/sme/contactGroup/page`,params);
  },
  //联系人组删除
  deleteContactGroup(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/contactGroup/delete`,param);
  },
  // 编辑联系人组
  updateContactGroup(params) {
    return $http.post(`${global.API_URL}/sme/contactGroup/update`,params);
  },

  //查询联系人日志
  listContactGroupOperationLogByContactGroupId(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/contactGroup/listContactGroupOperationLogByContactGroupId`,param);
  },
  // 联系人组中批量添加联系人接口
  batchCreate(params) {
    return $http.post(`${global.API_URL}/sme/contactGroupContactRelation/batchCreate`,params);
  },
  //在指定联系人组中删除指定联系人
  deleteByContactIdAndContactGroupId(params) {
    return $http.post(`${global.API_URL}/sme/contactGroupContactRelation/deleteByContactIdAndContactGroupId`,params);
  },
  //根据账号查询当前公司下有的联系人组
  listContactGroupsByAccountId(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/contactGroup/listContactGroupsByAccountId`,param);
  },
   //根据账户组查联系人组
   listContactGroupsByAccountGroupId(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/contactGroup/listContactGroupsByAccountGroupId`,param);
  },
}

export default contactGroup;



// WEBPACK FOOTER //
// ./src/api/contactGroup.js